import { MenuItem } from "@mui/material";
import ListItemText from "@mui/material/ListItemText";
import { OVERFLOW_MESSAGE_TEMPLATE } from "../../../../AssetsFilterTags.constants";

interface TagFamilyOverflowProps {
  hiddenCount: number;
}

export default function TagFamilyOverflow({ hiddenCount }: TagFamilyOverflowProps) {
  return (
    <MenuItem disabled className="py-0.5">
      <ListItemText
        primary={OVERFLOW_MESSAGE_TEMPLATE(hiddenCount)}
        slotProps={{
          primary: {
            className: "text-xs text-secondary italic",
          },
        }}
      />
    </MenuItem>
  );
}
